import { render, staticRenderFns } from "./unitOwnershipTransfer.vue?vue&type=template&id=18f73882&scoped=true&"
import script from "./unitOwnershipTransfer.vue?vue&type=script&lang=js&"
export * from "./unitOwnershipTransfer.vue?vue&type=script&lang=js&"
import style0 from "./unitOwnershipTransfer.vue?vue&type=style&index=0&id=18f73882&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "18f73882",
  null
  
)

export default component.exports